module.exports = __webpack_public_path__ + "b6fc94da10f1e481b5fafe93f03d805f.MP3";